import {
    REGISTERED_NUMBER_LOADING,
    REGISTERED_NUMBER_DELETED,
    REGISTERED_NUMBER_CREATED,
    REGISTERED_NUMBER_LOADED,
    REGISTERED_NUMBER_SEARCH,
    REGISTERED_NUMBER_EDITED,
    REGISTERED_NUMBER_FAILED,
    VOICE_PRODUCT_LOADING,
    VOICE_PRODUCT_LOADED,
    VOICE_PRODUCT_SEARCH,
    VOICE_PRODUCT_CREATED,
    VOICE_PRODUCT_EDITED,
    VOICE_PRODUCT_DELETED,
    VOICE_PRODUCT_FAILED,
    VOICE_CONTENT_LOADING,
    VOICE_CONTENT_LOADED,
    VOICE_CONTENT_SEARCH,
    VOICE_CONTENT_CREATED,
    VOICE_CONTENT_EDITED,
    VOICE_CONTENT_DELETED,
    VOICE_CONTENT_FAILED,
    COMPANY_NUMBER_LOADING,
    COMPANY_NUMBER_DELETED,
    COMPANY_NUMBER_CREATED,
    COMPANY_NUMBER_EDITED,
    COMPANY_NUMBER_LOADED,
    COMPANY_NUMBER_SEARCH,
    COMPANY_NUMBER_GOT,
    COMPANY_NUMBER_FAILED,
    VOICE_LOG_LOADING,
    VOICE_LOG_LOADED,
    VOICE_LOG_FAILED,
    VOICE_EVENTS_LOADING,
    VOICE_EVENTS_LOADED,
    VOICE_EVENTS_FAILED,
    LOGOUT,
} from 'redux/types';
import { created, editedUpdate, deleteFromState } from 'helpers/reduxUtils';

const initialState = {
    loading: false,
    voiceEvents: [],
    voiceLogs: [],
    registeredNumbers: [],
    companyNumbers: [],
    voiceContents: [],
    voiceProducts: [],
    companyNumber: null,
    registeredNumbersSearched: [],
    companyNumbersSearched: [],
    voiceContentsSearched: [],
    voiceProductsSearched: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case VOICE_LOG_LOADING:
        case VOICE_EVENTS_LOADING:
        case VOICE_PRODUCT_LOADING:
        case VOICE_CONTENT_LOADING:
        case COMPANY_NUMBER_LOADING:
        case REGISTERED_NUMBER_LOADING:
            return {
                ...state,
                loading: true,
            };

        case REGISTERED_NUMBER_CREATED:
            return {
                ...state,
                loading: false,
                registeredNumbers: created(state.registeredNumbers, action.payload),
            };

        case VOICE_PRODUCT_CREATED:
            return {
                ...state,
                loading: false,
                voiceProducts: created(state.voiceProducts, action.payload),
            };

        case VOICE_CONTENT_CREATED:
            return {
                ...state,
                loading: false,
                voiceContents: created(state.voiceContents, action.payload),
            };

        case COMPANY_NUMBER_CREATED:
            return {
                ...state,
                loading: false,
                companyNumbers: created(state.companyNumbers, action.payload),
            };

        case COMPANY_NUMBER_EDITED:
            return {
                ...state,
                loading: false,
                companyNumbers: editedUpdate(state.companyNumbers, action.payload),
                companyNumbersSearched: editedUpdate(
                    state.companyNumbersSearched,
                    action.payload
                ),
            };

        case REGISTERED_NUMBER_EDITED:
            return {
                ...state,
                loading: false,
                registeredNumbers: editedUpdate(
                    state.registeredNumbers,
                    action.payload
                ),
                registeredNumbersSearched: editedUpdate(
                    state.registeredNumbersSearched,
                    action.payload
                ),
            };

        case VOICE_PRODUCT_EDITED:
            return {
                ...state,
                loading: false,
                voiceProducts: editedUpdate(state.voiceProducts, action.payload),
                voiceProductsSearched: editedUpdate(
                    state.voiceProductsSearched,
                    action.payload
                ),
            };

        case VOICE_CONTENT_EDITED:
            return {
                ...state,
                loading: false,
                voiceContents: editedUpdate(state.voiceContents, action.payload),
                voiceContentsSearched: editedUpdate(
                    state.voiceContentsSearched,
                    action.payload
                ),
            };

        case REGISTERED_NUMBER_LOADED:
            return {
                ...state,
                loading: false,
                registeredNumbers: action.payload,
            };
        case VOICE_EVENTS_LOADED:
            return {
                ...state,
                loading: false,
                voiceEvents: action.payload,
            };
        case VOICE_LOG_LOADED:
            return {
                ...state,
                loading: false,
                voiceLogs: action.payload,
            };

        case VOICE_PRODUCT_LOADED:
            return {
                ...state,
                loading: false,
                voiceProducts: action.payload,
            };

        case VOICE_CONTENT_LOADED:
            return {
                ...state,
                loading: false,
                voiceContents: action.payload,
            };

        case COMPANY_NUMBER_LOADED:
            return {
                ...state,
                loading: false,
                companyNumbers: action.payload,
                companyNumber: null,
            };

        case REGISTERED_NUMBER_SEARCH:
            return {
                ...state,
                loading: false,
                registeredNumbersSearched: action.payload,
            };

        case VOICE_PRODUCT_SEARCH:
            return {
                ...state,
                loading: false,
                voiceProductsSearched: action.payload,
            };

        case COMPANY_NUMBER_SEARCH:
            return {
                ...state,
                loading: false,
                companyNumbersSearched: action.payload,
            };

        case VOICE_CONTENT_SEARCH:
            return {
                ...state,
                loading: false,
                voiceContentsSearched: action.payload,
            };

        case COMPANY_NUMBER_GOT:
            return {
                ...state,
                loading: false,
                companyNumber: action.payload,
            };

        case COMPANY_NUMBER_DELETED:
            return {
                ...state,
                loading: false,
                companyNumbers: deleteFromState(state.companyNumbers, action.payload),
                companyNumbersSearched: deleteFromState(
                    state.companyNumbersSearched,
                    action.payload
                ),
            };

        case VOICE_PRODUCT_DELETED:
            return {
                ...state,
                loading: false,
                voiceProducts: deleteFromState(state.voiceProducts, action.payload),
                voiceProductsSearched: deleteFromState(
                    state.voiceContentsSearched,
                    action.payload
                ),
            };

        case VOICE_CONTENT_DELETED:
            return {
                ...state,
                loading: false,
                voiceContents: deleteFromState(state.voiceContents, action.payload),
                voiceContentsSearched: deleteFromState(
                    state.voiceContentsSearched,
                    action.payload
                ),
            };

        case REGISTERED_NUMBER_DELETED:
            return {
                ...state,
                loading: false,
                registeredNumbers: deleteFromState(
                    state.registeredNumbers,
                    action.payload
                ),
                registeredNumbersSearched: deleteFromState(
                    state.registeredNumbersSearched,
                    action.payload
                ),
            };

        case REGISTERED_NUMBER_FAILED:
        case VOICE_CONTENT_FAILED:
        case VOICE_PRODUCT_FAILED:
        case COMPANY_NUMBER_FAILED:
        case VOICE_EVENTS_FAILED:
        case VOICE_LOG_FAILED:
            return {
                ...state,
                loading: false,
            };

        case LOGOUT:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
